import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { ThemeProvider } from "./theme/ThemeContext";
import { HardwareProvider } from "./data/HardwareContext";
import { OpsProvider } from "./data/OpsContext";
import { ElevatedSessionsProvider } from "./data/ElevatedSessionsContext";
import { ProjectsProvider } from "./data/ProjectsContext";
import { BillingProvider } from "./data/BillingContext";
import { NotificationsProvider } from "./data/NotificationsContext";
import { RolesProvider } from "./data/RolesContext";
import { UsersProvider } from "./data/UsersContext";
import { AuditProvider } from "./data/AuditContext";
import { ToastProvider } from "./toast/ToastContext";
import { PersonalCenterProvider } from "./data/PersonalCenterContext";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <RolesProvider>
          <HardwareProvider>
            <ProjectsProvider>
              <BillingProvider>
              <NotificationsProvider>
              <OpsProvider>
                <ElevatedSessionsProvider>
                  <UsersProvider>
                    <AuditProvider>
                      <BrowserRouter>
                        <ToastProvider>
                          <PersonalCenterProvider>
                            <App />
                          </PersonalCenterProvider>
                        </ToastProvider>
                      </BrowserRouter>
                    </AuditProvider>
                  </UsersProvider>
                </ElevatedSessionsProvider>
              </OpsProvider>
              </NotificationsProvider>
              </BillingProvider>
            </ProjectsProvider>
          </HardwareProvider>
        </RolesProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
